import { Divider, Flex, Text } from '@chakra-ui/react'
import { useEffect, useReducer } from 'react'

export function Timer() {
  const [timer, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'start':
          const now = new Date()
          const start = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            14
          )
          let time
          if (now < start) {
            time = start - now
          } else {
            //logica para atualizar tela e zerar endpoint (posteriormente)
            const tomorrow = new Date(now)
            tomorrow.setDate(now.getDate() + 1)
            const startTomorrow = new Date(
              tomorrow.getFullYear(),
              tomorrow.getMonth(),
              tomorrow.getDate(),
              14
            )
            time = startTomorrow - now
          }
          return { ...state, time, running: true }
        case 'stop':
          return { ...state, running: false }

        case 'reset':
          const resetTime = new Date()
          resetTime.setDate(resetTime.getDate() + 1)
          resetTime.setHours(14, 0, 0, 0)
          const resetStart = resetTime - new Date()
          return { ...state, time: resetStart, running: true }
        default:
          return state
      }
    },
    () => {
      const local = localStorage.getItem('@innovationbrindes-timer')
      return local ? JSON.parse(local) : { time: 0, running: false }
    }
  )

  useEffect(() => {
    localStorage.setItem('@innovationbrindes-timer', JSON.stringify(timer))
  }, [timer])

  useEffect(() => {
    if (timer.running) {
      const interval = setInterval(() => {
        dispatch({ type: 'start' })
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [timer.running])

  useEffect(() => {
    dispatch({ type: 'start' })
  }, [])

  return (
    <>
      {timer.running && (
        <Flex alignItems="center" justifyContent="center" gap={2}>
          <Divider
            sx={{
              borderColor: '#ccc',
            }}
          />
          <Text fontSize="30px" fontWeight="bold">
            {new Date(timer.time).toISOString().substr(11, 8)}
          </Text>
          <Divider
            sx={{
              borderColor: '#ccc',
            }}
          />
        </Flex>
      )}
    </>
  )
}
